import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    this.enabled = false
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(e) {
    if (e.key === "Escape") {
      this.reset()
      return
    }
    if (e.metaKey || e.ctrlKey || e.altKey) return
    if (!this.hasInputTarget) return

    if (e.key.toLowerCase() === "t" && document.activeElement !== this.inputTarget) {
      const modal = this.element.closest("[data-deck-target='engravingModal']")
      if (!modal || modal.classList.contains("hidden")) return
      e.preventDefault()
      if (this.enabled) {
        this.reset()
      } else {
        this.enable()
      }
    }
  }

  enable() {
    this.enabled = true
    this.buttonTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  filter() {
    const deckEl = this.element.closest("[data-controller='deck']")
    if (!deckEl) return
    const deck = this.application.getControllerForElementAndIdentifier(deckEl, "deck")
    if (!deck) return
    deck.searchEngravings()
  }

  reset() {
    this.enabled = false
    this.inputTarget.value = ""
    this.inputTarget.classList.add("hidden")
    this.buttonTarget.classList.remove("hidden")
    this.filter()
  }
}
